import { OaScoreType } from '../models/oa-score-type.enum';
import { TranslationKeyMap } from '../my-coaching-card.i18n';

export const CoachingItemsOaScoreTypeTranslationMap = {
    [OaScoreType.OA]: TranslationKeyMap._7463_OA,
    [OaScoreType.Area_OA]: TranslationKeyMap._9910_AREA_OA,
    [OaScoreType.LOB_OA]: TranslationKeyMap._9911_LOB_OA,
    [OaScoreType.Peer_Group_OA]: TranslationKeyMap._9912_PEERGROUP_OA,
    [OaScoreType.Region_OA]: TranslationKeyMap._9913_REGION_OA,
    [OaScoreType.Site_OA]: TranslationKeyMap._9914_SITE_OA,
    [OaScoreType.Super_Group_OA]: TranslationKeyMap._9915_SUPERGROUP_OA,
    [OaScoreType.Other]: TranslationKeyMap._9603_OTHER,
};
